import { countAllFilters } from 'src/filters/countAllFilters';
import { RootState } from 'src/store';

export const selectStudentsPage = (state: RootState) => state.studentsPage.page;
export const selectStudentsQueryString = (state: RootState) => state.studentsPage.query;
export const selectStudentsFilters = (state: RootState) => state.studentsPage.filters;
export const selectStudentsFiltersCount = (state: RootState) =>
  countAllFilters(state.studentsPage.filters);
export const selectShowInactiveStudents = (state: RootState) => state.studentsPage.showInactive;
